import React from "react";
import FooterVersion from "./sidebar-footer-version";
import TagVendor from "./sidebar-tag-vendor";

interface SidebarFooterProps {
  readonly render?: boolean;
}

function SidebarFooter(props: SidebarFooterProps) {
  const { render = true } = props;

  if (!render) {
    return null;
  }

  return (
    <div className="grid gap-4 border-t bg-sidebar-footer px-4 shadow-custom-top dark:border-gray-600 dark:bg-gray-900">
      {/* Section Vendor */}
      <TagVendor />

      {/* Section GroowCity Version */}
      <FooterVersion />
    </div>
  );
}

export default React.memo(SidebarFooter);
